module.exports = __webpack_public_path__ + "static/img/weather.742cc8c0.svg";